import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, DatePicker, Input, message, Modal, Row, Select, Form, TimePicker } from "antd"
import { useForm } from "antd/lib/form/Form"
import { DeleteOutlined } from '@ant-design/icons'
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import moment from "moment"
import _ from 'lodash'

const { RangePicker } = DatePicker
const { Option } = Select

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 14 }
}

interface checkInRecordData {
    room_number: string,
    check_in_day_range: string,
    room_type_name: string
}

interface Prop {
    checkInRecordData?: checkInRecordData[]
    clientData?: Client
    onChange?: () => void
}

interface Client {
    check_in_id: string // 入住id
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期（预计入住时间）
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    deal_item_name: string // 签单套餐名称
    check_in_total_days: number // 入住总天数，整数类型
    check_in_already_days: number // 已入住天数，整数类型
    check_in_left_days: number // 剩余天数，整数类型
    item_days: number // 套餐入住天数，整数类型
    gift_days: number // 赠送天数，整数类型
    deal_records_remark: string // 签单备注
    store_id: string // 签单门店id
    deal_prov_pic_list: string // 合同凭证图片
    check_in_status: number // 0待分配 1已预订 2已入住 3已出所，整数类型
    already_notify: number
}

interface notifyData {
    specific_time: string // 具体时间
    born_hospital: string // 分娩医院
    clothes_size: number // 衣服尺码，数字类型
    shoes_size: number // 月子鞋码数，数字类型
    food_attention: string // 饮食禁忌
    prepare_food_turn: string // 准备餐次，1早餐 2加餐 3午餐 4间餐 5晚餐 6宵夜，多个用英文逗号拼接
    need_drive: number // 是否需要车接
    take_drive_time: string // 车接时间
    take_drive_address: string // 车接地址
    need_wheel_chair: number // 轮椅
    need_baby_basket: string // 婴儿提篮
    remark: string // 备注
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    useEffect(() => {
        if (prop.clientData && prop.clientData.already_notify == 1) {
            baseAxiosNoInfo('/keeper/check_in/detail/query_notify_info', {
                params: {
                    check_in_id: param.id
                }

            }).then((res: any) => {
                if (res) {
                    form.setFieldsValue({
                        specific_time: moment(res.specific_time, 'HH:mm:ss'),
                        born_hospital: res.born_hospital,
                        clothes_size: res.clothes_size,
                        shoes_size: res.shoes_size,
                        food_attention: res.food_attention,
                        remark: res.remark,
                        born_way: res.born_way,
                        actually_born_day: moment(res.actually_born_day),
                        check_in_number: res.check_in_number,
                        born_preg_times: res.born_preg_times,
                        check_in_native_place: res.check_in_native_place,
                        check_in_birthday: moment(res.check_in_birthday),
                        hubby_user_name: res.hubby_user_name,
                        hubby_phone: res.hubby_phone,
                        family_address: res.family_address,
                        feeding_way: res.feeding_way,
                        special_matters: res.special_matters,
                        allergy: res.allergy,
                        special_attention_matters: res.special_attention_matters,
                    })

                    setReciveMoneyData(res.baby_list)
                }
            })
        }
    }, [prop])

    const onFinish = () => {
        if (prop.clientData?.already_notify === 0) {
            baseAxiosComplete.post('/keeper/check_in/detail/submit_notify', {
                check_in_id: param.id,
                specific_time: form.getFieldValue('specific_time').format('HH:mm:ss'), // 具体时间
                born_hospital: form.getFieldValue('born_hospital'), // 分娩医院
                actually_born_day: form.getFieldValue('actually_born_day') ? form.getFieldValue('actually_born_day').format('YYYY-MM-DD') : '',
                born_way: form.getFieldValue('born_way'),
                clothes_size: form.getFieldValue('clothes_size'), // 衣服尺码，数字类型
                shoes_size: form.getFieldValue('shoes_size'), // 月子鞋码数，数字类型
                check_in_number: form.getFieldValue('check_in_number'),
                born_preg_times: form.getFieldValue('born_preg_times'),
                check_in_native_place: form.getFieldValue('check_in_native_place'),
                check_in_birthday: form.getFieldValue('check_in_birthday') ? form.getFieldValue('check_in_birthday').format('YYYY-MM-DD') : '',
                hubby_user_name: form.getFieldValue('hubby_user_name'),
                hubby_phone: form.getFieldValue('hubby_phone'),
                family_address: form.getFieldValue('family_address'),
                baby_list: reciveMoneyData,
                feeding_way: form.getFieldValue('feeding_way'),
                special_matters: form.getFieldValue('special_matters'),
                food_attention: form.getFieldValue('food_attention'), // 饮食禁忌
                allergy: form.getFieldValue('allergy'),
                special_attention_matters: form.getFieldValue('special_attention_matters'),
                remark: form.getFieldValue('remark'), // 备注
            }).then(res => {
                if (res.status === 0) {
                    setVisible(false)
                    if (prop.onChange) prop.onChange()
                }
            })

        } else {
            message.error('已通知入住后不可修改')
        }
    }

    interface reciveRow {
        sex: undefined | number,
        nick_name: undefined | string,
        weight: undefined | string,
        jaundice_value: undefined | string
    }

    let reciveMoneyRow: reciveRow = {
        sex: undefined,
        nick_name: undefined,
        weight: undefined,
        jaundice_value: undefined
    }

    const [reciveMoneyData, setReciveMoneyData] = useState<reciveRow[]>([])
    const addMoreRow = () => {
        setReciveMoneyData([...reciveMoneyData, reciveMoneyRow])
    }

    const deleteRow = (index: number) => {
        if (reciveMoneyData.length > 1) {
            let reciveD = _.cloneDeep(reciveMoneyData)
            reciveD.splice(index, 1)

            setReciveMoneyData(reciveD)
        }
    }

    const handleChange = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)
        reciveD[index][attr] = value

        setReciveMoneyData(reciveD)
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 通知入住 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>通知入住</Button>

        <Modal title="通知入住" width={700} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <p>如要调整入住日期，请先使用调整房间功能</p>
            <p style={{ fontWeight: 'bold', fontSize: 16 }}>带红色<span style={{ color: 'red' }}>*</span>号的表单项为必填项，请填写完整再提交表单！</p>

            <p style={{ marginTop: 20 }}>入住房号：{prop.checkInRecordData?.length && prop.checkInRecordData[0].room_number}</p>
            <p>入住日期：{prop.checkInRecordData?.length && prop.checkInRecordData[0].check_in_day_range}</p>
            <p>入住天数：{prop.clientData && prop.clientData?.item_days}</p>

            <Form form={form} {...formItemLayout} style={{ marginTop: 20 }} >
                <Form.Item required name="specific_time" label="具体时间">
                    <TimePicker />
                </Form.Item>

                <Form.Item name="born_hospital" label="分娩医院">
                    <Input />
                </Form.Item>

                <Form.Item required label="分娩日期" name="actually_born_day">
                    <DatePicker />
                </Form.Item>

                <Form.Item required name="born_way" label="分娩方式">
                    <Select >
                        <Option key={1} value={1}>顺产</Option>
                        <Option key={2} value={2}>剖腹产</Option>
                    </Select>
                </Form.Item>

                <Form.Item required name="check_in_number" label="入所次数">
                    <Select >
                        <Option key={1} value={1}>1</Option>
                        <Option key={2} value={2}>2</Option>
                        <Option key={3} value={3}>3</Option>
                        <Option key={4} value={4}>4</Option>
                        <Option key={5} value={5}>5</Option>
                        <Option key={6} value={6}>6</Option>
                    </Select>
                </Form.Item>

                <Form.Item required name="born_preg_times" label="分娩胎次">
                    <Select >
                        <Option key={1} value={1}>1</Option>
                        <Option key={2} value={2}>2</Option>
                        <Option key={3} value={3}>3</Option>
                        <Option key={4} value={4}>4</Option>
                        <Option key={5} value={5}>5</Option>
                        <Option key={6} value={6}>6</Option>
                    </Select>
                </Form.Item>

                <Form.Item required label="宝妈生日" name="check_in_birthday">
                    <DatePicker />
                </Form.Item>

                <Form.Item required name="feeding_way" label="喂养方式">
                    <Select >
                        <Option key={1} value={1}>纯母乳</Option>
                        <Option key={2} value={2}>纯牛奶</Option>
                        <Option key={3} value={3}>混合喂养</Option>
                    </Select>
                </Form.Item>

                <Row style={{ marginBottom: 16 }} gutter={8} justify="space-around">
                    <Col span={3}>宝宝姓名</Col>
                    <Col span={3}>体重</Col>
                    <Col span={3}>性别</Col>
                    <Col span={3}>黄疸值</Col>
                    <Col span={1}></Col>
                </Row>

                {reciveMoneyData.map((el, index: number) => <Row gutter={8} justify="space-around" style={{ marginBottom: 8, userSelect: 'none' }}>
                    <Col span={3}><Input value={el.nick_name} onChange={(e) => {
                        handleChange(index, 'nick_name', e.target.value)
                    }} /></Col>

                    <Col span={3}><Input value={el.weight} onChange={(v) => {
                        handleChange(index, 'weight', v.target.value)
                    }} /></Col>

                    <Col span={3}>
                        <Select value={el.sex} style={{ width: '100%' }} onChange={(v: number) => {
                            handleChange(index, 'sex', v)
                        }}>
                            <Option key={0} value={0}>男</Option>
                            <Option key={1} value={1}>女</Option>
                        </Select>
                    </Col>

                    <Col span={3}><Input value={el.jaundice_value} onChange={(v) => {
                        handleChange(index, 'jaundice_value', v.target.value)
                    }} /></Col>

                    <Col span={1} style={{ paddingTop: 4 }}>
                        <DeleteOutlined onClick={() => {
                            deleteRow(index)
                        }} style={{ cursor: 'pointer' }} />
                    </Col>
                </Row>)}

                <Button onClick={addMoreRow} style={{ margin: '0 auto 20px', display: 'block' }} size="small" type="primary">添加宝宝</Button>

                <Form.Item name="clothes_size" label="衣服尺码">
                    <Input placeholder="输入数字" />
                </Form.Item>

                <Form.Item name="shoes_size" label="鞋子码数">
                    <Input placeholder="输入数字" />
                </Form.Item>

                <Form.Item name="check_in_native_place" label="宝妈籍贯">
                    <Input />
                </Form.Item>

                <Form.Item label="先生姓名" name="hubby_user_name">
                    <Input />
                </Form.Item>

                <Form.Item label="先生电话" name="hubby_phone">
                    <Input />
                </Form.Item>

                <Form.Item label="家庭住址" name="family_address">
                    <Input />
                </Form.Item>

                <Form.Item name="special_matters" label="孕期特殊事项">
                    <Input />
                </Form.Item>

                <Form.Item name="allergy" label="过敏史">
                    <Input />
                </Form.Item>

                <Form.Item name="food_attention" label="饮食禁忌">
                    <Input />
                </Form.Item>

                <Form.Item name="special_attention_matters" label="特殊注意事项">
                    <Input />
                </Form.Item>

                <Form.Item name="remark" label="备注">
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    </Fragment>
}